import React from 'react';

// @ts-ignore
import toSorted from 'array.prototype.tosorted';
// @ts-ignore
toSorted.shim();

import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import './utils/muyi-bridge';
import { App } from './containers/App';

import './main.scss';
import 'rc-select/assets/index.less';

// eslint-disable-next-line import/order
import './wdyr';

import { pdfjs } from 'react-pdf';
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

Sentry.init({
  dsn: 'https://bda1c768b1cb05cd75dc9726cfc6afe9@sentry.mikuzz.cn/4',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/muyi\.xinyixue\.art/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

if (location.pathname.match(/^\/invitation\/[A-Z]{6}$/)) {
  const invitationCode = location.pathname.split('/')[2];
  window.location.href = `${location.origin}?ci=${invitationCode}`;
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

